import Svg, { Path, Circle } from 'react-native-svg';
import { withDefaultIconProps } from './index';

interface ArrowProps {
  color?: string;
  arrowColor?: string;
  reverse?: boolean;
}

export const ArrowRight = withDefaultIconProps(
  {
    height: 30,
    width: 31,
  },
  ({ color: circleColor, arrowColor, reverse = false, ...rest }: ArrowProps) => (
    <Svg
      {...rest}
      viewBox="0 0 31 30"
      // flip horizontally around center when reverse === true
      style={reverse ? { transform: [{ scaleX: -1 }] } : undefined}
    >
      <Circle cx="15.3701" cy="15" fill={circleColor} r="14.5" stroke={circleColor} />
      <Path
        d="M7.94 15.57H21.43L16.83 20.17C16.61 20.4 16.61 20.76 16.83 20.98C16.94 21.09 17.08 21.14 17.23 21.14C17.37 21.14 17.52 21.09 17.63 20.98L23.21 15.4C23.33 15.24 23.37 15 23.37 15C23.37 14.99 23.37 14.98 23.37 14.97L23.21 14.6L17.63 9.02C17.41 8.8 17.05 8.8 16.83 9.02C16.61 9.24 16.61 9.6 16.83 9.83L21.43 14.43H7.94C7.62 14.43 7.37 14.69 7.37 15C7.37 15.31 7.62 15.57 7.94 15.57Z"
        fill={arrowColor}
      />
    </Svg>
  ),
);
